let language = {
    "MY-ACCOUNT-SOCIAL-NETWORK-TIPS": "You are currently logging in to our website by",

    "MY-ACCOUNT-FORM-EMPTY-TIPS": "Can't be empty!",
    "MY-ACCOUNT-FORM-SAVE-BUTTON": "Save",

    // user info form
    "MY-ACCOUNT-USER-INFO-CONTAINER-TITLE": "Basic Information",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-USER-NAME": "UserName",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-EMAIL": "Email",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-EMAIL-CHANGE-BUTTON": "Change",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-EMAIL-NEW": "New Email",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-EMAIL-NEW-TIPS": "To set up the new email address, follow the instructions in the confirmation email which has been sent to",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-GENDER": "Gender",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-GENDER-MALE": "Gender",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-GENDER-FEMALE": "Female",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-GENDER-DIVERSE": "Diverse",
    "MY-ACCOUNT-USER-INFO-CONTAINER-FORM-BIRTH-DATE": "Date Of Birth",

    // password form
    "MY-ACCOUNT-PASSWORD-CONTAINER-TITLE": "Password",
    "MY-ACCOUNT-PASSWORD-FORM-OLD": "Old Password",
    "MY-ACCOUNT-PASSWORD-FORM-NEW": "New Password",

    "MY-ACCOUNT-VERIFICATION-SUCCESS": "Email Verification Succeeded !",
};

export { language }